/* eslint-disable import/prefer-default-export */
export const environment = "production";
export const SENTRY_DSN =
  "https://ba4834d34e7b42a59928443d533be561@o65941.ingest.sentry.io/6033476";
export const COMPANY_ACCOUNT_MANAGER_DOMAIN = "https://company-account-manager.finc.com";
export const APP_DIETCOACH_DOMAIN = "https://app-dietcoach.finc.com";
export const SURVEY_DOMAIN = "https://wellness-survey.finc.com";
export const HELP_DOMAIN = "https://finc-help.tayori.com";
export const PERSONAL_INFO_URL = "https://finc.com/legal/privacy#info";
export const datadogRumConfig = {
  applicationId: "8195cca7-6e0b-4660-bda9-7fa66c332c39",
  clientToken: "pube646eed749c77669a9e96b419f3c922b",
  site: "datadoghq.com",
  service: "wellness_survey",
  env: "production",
  version: "1.0.0",
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  defaultPrivacyLevel: "allow",
  trackSessionAcrossSubdomains: true
};
/* eslint-enable import/prefer-default-export */
